import { createAsyncThunk } from '@reduxjs/toolkit';
import { AppServerResponse } from '../../utils/interfaces/generalInterfaces';
import axios from 'axios';
import { BASE_API_URL } from '../../utils/constants';
import { logoutUser } from './authService';
import { myFirebaseAuth } from '../../firebase/config';
import { CreditApplicationMonitorUpdate } from '@dill/dill-shared';

export const createCreditApplicationMonitor = createAsyncThunk(
  'creditApplicationsMonitor/createCreditApplicationMonitor',
  async (
    {
      companyNACMID,
      creditApplicationId,
      supplierId,
    }: {
      companyNACMID: string;
      creditApplicationId: string;
      supplierId: string;
    },
    thunkApi
  ) => {
    try {
      const token = await myFirebaseAuth.currentUser?.getIdToken();
      if (!token) {
        return null;
      }
      const response = await axios.post<AppServerResponse>(
        `${BASE_API_URL}/suppliers/${supplierId}/creditApplicationsMonitor/createCreditApplicationMonitor`,
        {
          companyNACMID,
          creditApplicationId,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      return response.data;
    } catch (error: any) {
      console.log(error?.message);
      if (error?.response?.status === 401) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(error.message);
    }
  }
);

export const getSupplierCreditApplicationsMonitor = createAsyncThunk(
  'creditApplicationsMonitor/getSupplierCreditApplicationsMonitor',
  async ({ supplierId }: { supplierId: string }, thunkApi) => {
    const token = await myFirebaseAuth.currentUser?.getIdToken();
    if (!token) {
      return null;
    }
    try {
      const response = await axios.get<AppServerResponse>(
        `${BASE_API_URL}/suppliers/${supplierId}/creditApplicationsMonitor/getSupplierCreditApplicationsMonitor`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: {
            supplierId,
          },
        }
      );

      return response.data;
    } catch (error: any) {
      console.log(error?.message);
      if (error?.response?.status === 401) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(error.message);
    }
  }
);

export const getCreditApplicationMonitor = createAsyncThunk(
  'creditApplicationsMonitor/getCreditApplicationMonitor',
  async (
    {
      creditApplicationMonitorId,
      supplierId,
    }: { creditApplicationMonitorId: string; supplierId: string },
    thunkApi
  ) => {
    const token = await myFirebaseAuth.currentUser?.getIdToken();
    if (!token) {
      return null;
    }
    try {
      const response = await axios.get<AppServerResponse>(
        `${BASE_API_URL}/suppliers/${supplierId}/creditApplicationsMonitor/getCreditApplicationMonitor/${creditApplicationMonitorId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      return response.data;
    } catch (error: any) {
      console.log(error?.message);
      if (error?.response?.status === 401) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(error.message);
    }
  }
);

export const updateCreditApplicationMonitor = createAsyncThunk(
  'creditApplicationsMonitor/updateCreditApplicationMonitor',
  async (
    {
      creditApplicationMonitorId,
      supplierId,
      creditApplicationMonitorDetails,
    }: {
      creditApplicationMonitorId: string;
      supplierId: string;
      creditApplicationMonitorDetails: CreditApplicationMonitorUpdate;
    },
    thunkApi
  ) => {
    const token = await myFirebaseAuth.currentUser?.getIdToken();
    if (!token) {
      return null;
    }
    try {
      const response = await axios.put<AppServerResponse>(
        `${BASE_API_URL}/suppliers/${supplierId}/creditApplicationsMonitor/updateCreditApplicationMonitor/${creditApplicationMonitorId}`,
        { ...creditApplicationMonitorDetails },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      return response.data;
    } catch (error: any) {
      console.log(error);
      if (error?.response?.status === 401) {
        thunkApi.dispatch(logoutUser());
      }
      return thunkApi.rejectWithValue(error.message);
    }
  }
);
